<template>
  <Modal
      :show.sync="isOpen"
      :on-close="onClose"
      :class="'select_product_modal'"
    >
    <div>
        <h2 class="font_regular font_600 text_20">{{$t('COUPON.ADD_FORM.SELECT_PRODUCT_MODAL.HEADER_TITLE')}}</h2>
    </div>
    <SearchInputVue
        :placeholder="$t('COUPON.ADD_FORM.SELECT_PRODUCT_MODAL.PLACEHOLDER')"
        :className="'mt_10'"
    />
    <section class="mt_14">
        <h2 class="font_regular font_500 text_14">{{$t('COUPON.ADD_FORM.SELECT_PRODUCT_MODAL.SUB_TITLE')}}</h2>
        <div class="products_container">
            <ul class="products mt_12">
                <li
                    v-for="item in catalogueItems"
                    class=" my_12 ml_0"
                    :class="isSelected(item) ? 'active_item':''"
                    :key="item.id"
                    @click="onSelectProduct(item)"
                >
                <div class="product font_regular font_500 text_14">
                    <div class="image">
                        <CheckboxInput
                            :value="isSelected(item)"
                            :classNameWrapper="'input_check'"
                        />
                        <SHImage  :src="item.image_link"/>
                    </div>
                    <div class="px_10">
                        <h4 class="font_regular font_600 text_14 mt_8">{{item.title}}</h4>
                    </div>
                    <div class="price_inventory px_10 pb_10">
                        <div class="">
                            Price: {{item.price}}
                        </div>
                        <div>
                            Inventory: {{item.available_inventory}}
                        </div>
                    </div>
                </div>
                </li>
            </ul>
            <div>
                <LoadingState
                    v-if="uiFlags.isFetching_catalog_items" :message="$t('COUPON.ADD_FORM.SELECT_PRODUCT_MODAL.LOADING_MSG')"
                />
                <EmptyState
                    v-if="!uiFlags.isFetching_catalog_items && !catalogueItems.length"
                    :message="$t('COUPON.ADD_FORM.SELECT_PRODUCT_MODAL.EMPTY_MSG')"
                />
            </div>
            <div>
                <woot-button
                    variant="clear"
                    size="small"
                    class="load_more_btn"
                    color-scheme="primary"
                    :is-loading="uiFlags.isFetching_catalog_items"
                    :is-disabled="paginationCompute.isLastPage"
                    @click="onPageChange(Number(meta.currentPage)+1)"
                >
                {{paginationCompute.btnText}}
              </woot-button>
            </div>
        </div>
    </section>

    <div class="mt_8">
        <woot-button
            :disabled="false"
            :isLoading="false"
            @click="onDone"
        >
            {{$t('COUPON.ADD_FORM.SELECT_PRODUCT_MODAL.SUBMIT_BTN')}}
        </woot-button>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '../../../../../components/Modal.vue';
import SearchInputVue from '../../../../../components/ui/SearchInput.vue';
import SHImage from "../../../../../../shopApp/routes/shop/components/SHImage.vue"
import CheckboxInput from '../../../../../components/ui/inputs/CheckboxInput.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';


export default {
    components: {
        Modal,
        SearchInputVue,
        SHImage,
        CheckboxInput,
        LoadingState,
        EmptyState,
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        onClose: {
            type: Function,
            default: () => {},
        },
        products:{
            type: Array,
            default: []
        },
    },
    data(){
        return {
            searchText:"",
            filteredCategories: [],
        }
    },
    computed: {
        ...mapGetters({
        //   currentUser: 'getCurrentUser',
          uiFlags: "catalog/getUIFlags",
          meta: "catalog/getMeta",
          categories: "catalog/getCatagories",
          catalogueItems: "catalog/getCatalogItems",
        }),
        paginationCompute(){
            const totalPages = Math.ceil(this.meta.count / this.meta.pageSize);
            const isLastPage = this.meta.currentPage >= totalPages;
            const currentCount = Math.min(this.meta.currentPage * this.meta.pageSize, this.meta.count);
            const btnText = `${this.$t('CATALOGUE.PAGINATION_BTN')} (${currentCount}/${this.meta.count})`;

            return{
                isLastPage,
                btnText,
            }
        },
    },
    mounted(){
        this.fetchProductItems({});
    },
    methods:{
        onDone(){
            if (this.onClose) {
                this.onClose()
            }
        },
        fetchProductItems(query={}){
            this.$store.dispatch("catalog/getCatalogProductItems",query);
        },
        onPageChange(page,filterCategoryList=null) {
            this.$store.dispatch("catalog/getPaginatedCatalogProductItems",{
                currentPage:page,
                pageSize:this.meta.pageSize,
                searchText: this.searchText,
                categories: filterCategoryList? filterCategoryList: this.filteredCategories,
            })
        },
        onSelectProduct(item){
            const index = this.products.findIndex(el=>el.id === item.id);
            if (index < 0) {
                this.products.push(item);
            }else{
                this.products.splice(index,1)
            }
        },
        isSelected(item){
            const index = this.products.findIndex(el=>el.id === item.id);
            return index > -1;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.products_container{
    max-height: 50vh;
    overflow: auto;
}
.products{
    display: grid;
    grid-template-columns: repeat(3,1fr);
    gap: 12px;
    li{
        list-style: none;
        border: 1px solid transparent;
        border-radius: 8px;
        overflow: hidden;
        transition: all ease-in-out 0.2s;
    }
    .active_item{
        border-color: #8D25F6;
        transition: all ease-in-out 0.2s;
    }
}
.product{
    cursor: pointer;
    .image{
        position: relative;
        height: 195px;
        overflow: hidden;
    }
}
.input_check{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.price_inventory{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 4px;
}
.load_more_btn{
    display: block;
    margin: auto;
}
</style>
<style >
.select_product_modal .modal-container{
    width: 70rem;
}
</style>